import { render } from "./503Page.vue?vue&type=template&id=2e6620f8"
const script = {}

import "./503Page.vue?vue&type=style&index=0&id=2e6620f8&lang=css"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__